(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("BootstrapVue"), require("VueRouter"), require("vue"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["BootstrapVue", "VueRouter", , "axios"], factory);
	else if(typeof exports === 'object')
		exports["activity_finder_4"] = factory(require("BootstrapVue"), require("VueRouter"), require("vue"), require("axios"));
	else
		root["activity_finder_4"] = factory(root["BootstrapVue"], root["VueRouter"], root["Vue"], root["axios"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__0089__, __WEBPACK_EXTERNAL_MODULE__6389__, __WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_cebe__) {
return 